module.exports = __webpack_public_path__ + "static/media/logo.d66572cd.png";